import ChildrenCategoriesTypeEnum from 'Rentlio/utils/childrenCategoriesEnum'
import { childrenCategoryDerivationType } from 'Rentlio/utils/childrenCategoryDerivationType'

const getChildrenSelectedCategories = (childrenAges, childrenCategories) => {
  const selectedCategories = []
  if (!childrenAges || childrenAges.length === 0) {
    return selectedCategories
  }

  childrenAges.map(childAge => {
    let categoryIsFilled = false
    childrenCategories.map(category => {
      if (+childAge >= category.ageFrom && +childAge < category.ageTo) {
        categoryIsFilled = true
        return selectedCategories.push(category)
      }
    })
    // we are checking if category for child exists and if not we are setting price same as adult
    if (!categoryIsFilled) {
      selectedCategories.push({
        type: ChildrenCategoriesTypeEnum.AS_ADULT,
        percentageValue: 100,
        nominalValue: null,
        nominalValueBeforeTax: null,
        valueType: childrenCategoryDerivationType.PERCENTAGE
      })
    }
  })

  return selectedCategories
}

export default getChildrenSelectedCategories
